/*================================================
  smooth scroll
================================================*/

$(function(){
  $('.anchorLink li a[href^="#"]').click(function(){
    var adjust = 0;
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});


/*================================================
  ToggleModal
================================================*/

/**
 * @class ToggleModal
 * @description モーダルウィンドウの表示切替を行い、YouTube動画を動的に埋め込む
 * @argument target 対象のYouTube動画を含む要素
 */
class ToggleModal {
	constructor(target) {
		this.target = target;
		this.videoId = target.dataset.url.slice(-11);
		this.loadIframePlayerAPI();
		this.open();
		this.close();
	}

	/**
   * @method loadIframePlayerAPI
   * @description IFrame Player APIを読み込む
   */
	loadIframePlayerAPI() {
		const tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	/**
   * @method onYouTubeIframeAPIReady
   * @description YouTube動画を動的に埋め込む
   */
	onYouTubeIframeAPIReady() {
		let ytPlayer = new YT.Player('player', {
			videoId: this.videoId,
			playerVars: {
				'autoplay': 1,
				'controls': 1,
				'rel': 0
			}
		});
	}

	/**
   * @method remakePlayerElement
   * @description YouTube動画を埋め込む要素を再作成
   */
	remakePlayerElement() {
		const modal = document.querySelector('#modal-video');
		modal.removeChild(modal.firstElementChild);
		let tag = document.createElement('div');
		tag.id = 'player';
		modal.appendChild(tag);
	}

	/**
   * @method open
   * @description モーダルウィンドウを開く
   */
	open() {
		this.target.addEventListener('click', event => {
			this.onYouTubeIframeAPIReady();
			document.querySelector('#modal-video').classList.add('open');
			document.querySelector('#modal-video').classList.remove('close');
		});
	}

	/**
   * @method close
   * @description モーダルウィンドウを閉じる
   */
	close() {
		document.querySelector('.js-modal-video-close').addEventListener('click', event => {
			document.querySelector('#modal-video').classList.add('close');
			document.querySelector('#modal-video').classList.remove('open');
			this.remakePlayerElement();
		});
	}
}

document.addEventListener('DOMContentLoaded', event => {
	document.querySelectorAll('.js-modal-video-open').forEach(element => {
		new ToggleModal(element);
	});
});


/*================================================
  Top Slide
================================================*/

$('.top_mv_slide').slick({
	autoplay: true,
	fade: true,
	autoplaySpeed: 6000,
	speed: 3000,
	dots: true,
	pauseOnFocus: false,
	pauseOnHover: false,
	pauseOnDotsHover: false
});


/*================================================
  collections title
================================================*/

$(function(){
	$('.pagetitle-en').prependTo('.collection-hero__title .text, .page-title .text');
});

$(function(){
	var src = $('.pagetitle-bg').children('img').attr('src');
	$('.pagetitle-bg').parent().prev().css("background-image", 'url(' + src + ')');
});

$(function () {
	$('.collection-hero__inner').each(function () {
		var list = $(this).find('img');
		var srcImg = list.attr('src');
		var str = srcImg.replace(/&width=750/g, '');
		var srcOver = str.substr(0, str.lastIndexOf('.')) + str.substr(str.lastIndexOf('.'));
		$(this).find('.collection-hero__title').css('background-image', 'url(' + srcOver + ')');
	});
});